<app-kpi-widget
  [title]="'driverOverview.widgets.kilometersDriven' | transloco"
  [isLoading]="isLoading"
  [icon]="'ph-line-segment'"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [difference]="difference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [differenceFormatter]="formatDifference.bind(this)"
  (clicked)="openKilometersDrivenModal()"
  [isImageIcon]="false"
  [widgetDisabled]="false"
  [hasFooter]="false"
  [dropdownEnabled]="false">
</app-kpi-widget>